import React from 'react';
import { NavLink } from 'react-router-dom';
import { Toaster } from 'sonner';
import '../styles.css';

const crestUrl = "https://customer-assets.emergentagent.com/job_multi-brand-portal/artifacts/cf5fduyf_Academic%20Guild%20Crest.png";

export const Layout = ({ children }) => {
  return (
    <div className="guild-theme">
      <div className="arcane-overlay" aria-hidden />
      <div className="gold-vignette" aria-hidden />

      <div className="site-layer">
        <header className="guild-header-line bg-[#2a0c0c]/80 backdrop-blur">
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
            <img src={crestUrl} alt="Guild Crest" className="w-10 h-10" />
            <div className="flex flex-col">
              <span className="text-xs text-white/80">World Government • Academic Guild</span>
              <h1 className="brand-title text-2xl">Howling Hills Academic Guild</h1>
            </div>
            <nav className="ml-auto flex gap-2">
              <NavLink to="/Academic-Guild/apply" className={({isActive}) => `px-3 py-2 rounded-md ${isActive ? 'bg-white/10 text-white' : 'hover:bg-white/5 text-white'}`}>Application</NavLink>
              <NavLink to="/Academic-Guild/registry" className={({isActive}) => `px-3 py-2 rounded-md ${isActive ? 'bg-white/10 text-white' : 'hover:bg-white/5 text-white'}`}>Public Registry</NavLink>
              <NavLink to="/Academic-Guild/staff" className={({isActive}) => `px-3 py-2 rounded-md ${isActive ? 'bg-white/10 text-white' : 'hover:bg-white/5 text-white'}`}>Staff Review</NavLink>
            </nav>
          </div>
        </header>

        <main className="max-w-6xl mx-auto px-4 py-10">
          {children}
        </main>

        <Toaster richColors position="top-center" />
      </div>
    </div>
  );
};